import React, { createContext, useContext, ReactNode } from 'react';

interface SidebarContextType {
  isSidebarCollapsed: boolean;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

interface SidebarProviderProps {
  children: ReactNode;
  isSidebarCollapsed: boolean;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ 
  children, 
  isSidebarCollapsed 
}) => {
  return (
    <SidebarContext.Provider value={{ isSidebarCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};
